module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "docs-header"
  }, [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_vm._l((_vm.breadcrumb), function(item, index) {
    return [(_vm.routes[item]) ? _c('li', {
      key: item,
      class: {
        'is-active': index === _vm.breadcrumb.length - 1
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.routes[item].path
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.routes[item].breadTitle || _vm.routes[item].title) + "\n                        ")])], 1) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('h1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e304c31e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/components/TheHeader.vue
// module id = 1596
// module chunks = 300